<template>
	<div style="z-index: 1000000;position: absolute;">
		<Form ref="formInline" :model="formInline" inline style="text-align: left;margin-top: 1%;">
			<!-- Input Examples -->
			<FormItem prop="cityName">
				<Input style="width: 260px;" type="text" v-model="formInline.cityName" placeholder="详细地址">
				<span slot="prepend">详细地址</span>
				</Input>
			</FormItem>
			<FormItem>
				<Button type="primary" @click="selectCity">{{ $t('Common.Search') }}</Button>
			</FormItem>
		</Form>
	</div>
</template>

<script>
	export default {
		//props: ['param', 'url'],
		data() {
			return {
				formInline: {
					cityName: ''
				},
			};
		},
		computed: {},
		methods: {
			selectCity: function() {
				this.$emit('selectCity', this.formInline.cityName)
			}
		},
	}
</script>

<style>
</style>
